import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const shareApplicant = (
  jobApplicantId: number,
  toEmail: Array<{ email: string; name?: string }>,
  customMessage: string,
  selectedShareUserType: string,
) =>
  createGenericDispatcher({
    name: 'SHARE_APPLICANT',
    loadFunction: async () =>
      Api.post(`/application/${jobApplicantId}/share`, {
        body: JSON.stringify({
          toEmail,
          customMessage,
          selectedShareUserType,
        }),
      }),
    args: { jobApplicantId, toEmail, customMessage, selectedShareUserType },
  });
